import { setCreateRoot } from '@arco-design/web-react/es/_util/react-dom';
import { createRoot } from 'react-dom/client';
setCreateRoot(createRoot);
